
(function(){
     'use strict';

     angular
        .module('app')
        .filter('nl2br', function($sce){
      return function(msg,is_xhtml) { 
          var is_xhtml = is_xhtml || true;
          var breakTag = (is_xhtml) ? '<br />' : '<br>';
          var msg = (msg + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
          console.log($sce);

          return $sce.trustAsHtml(msg);
      }
  });


})();

